import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { ArrayUnique, IsArray, IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { MenuSyncConfigExposeGroup } from '../interface';
export class ReadMenuSyncOptionsDto {
}
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsString({ each: true, always: true }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadMenuSyncOptionsDto.prototype, "skipTaxIds", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadMenuSyncOptionsDto.prototype, "skipAllTaxes", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadMenuSyncOptionsDto.prototype, "isStoreSpecific", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadMenuSyncOptionsDto.prototype, "createStoreItemGroups", void 0);
//# sourceMappingURL=ReadMenuSyncOptionsDto.js.map